import { Box, Stack, Typography, styled, useMediaQuery, useTheme } from '@mui/material';
import { ErrorBoundaryXcala } from '../ErrorBoundaryXcala';
import BtnGroupWallet from './BtnGroupWallet';
import CoinFloating from './CoinFloating';
import TabletGridWallet from './TabletGridWallet';
import { TotalWallet } from './TotalWallet';

const WrapperSection = styled(Stack)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));
const TitleContainer = styled(Stack)(({ theme }) => ({
  width: '80%',
  justifyContent: 'center',
  height: '70px',
  textAlign: 'start',
  marginTop: '14px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  [theme.breakpoints.down('md')]: {
    width: '100%',
    textAlign: 'center',
  },
}));
const TitleText = styled(Typography)(({ theme }) => ({
  marginLeft: '20px',
  fontWeight: theme.typography.signInWelcome.fontWeight,
  color: theme.palette.primary.main,
  fontSize: theme.typography.h1.fontSize,
  [theme.breakpoints.down('md')]: {
    fontSize: theme.typography.profile.fontSize,
    marginLeft: '0px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.titleText.fontSize,
    marginLeft: '0px',
  },
}));
const StackTransaction = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '16px',
  display: 'flex',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '16px 12px',
  boxSizing: 'border-box',
  minHeight: '486px',
  width: '100%',
  margin: '0px auto',
  paddingTop: '16px',

  [theme.breakpoints.up('lg')]: {
    width: '40%',
  },
}));
const StackAvailable = styled(Stack)(({ theme }) => ({
  position: 'relative',
  marginTop: '0 auto',
  backgroundColor: theme.palette.white.main,
  boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
  borderTop: '1px solid rgba(170, 167, 167, 0.25)',
  borderRadius: '8px',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '16px 24px',
  boxSizing: 'border-box',
  overflow: 'hidden',
  height: '121px',
  width: '100%',
  gap: '8px',
  animation: 'ease-in-out',
  [theme.breakpoints.down('md')]: {
    height: '90px',
    marginTop: '20px',
  },
}));
const AssetsTitle = styled(Stack)({
  borderRadius: '4px',
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '4px 0px',
  boxSizing: 'border-box',
  width: '100%',
  margin: '0px',
});
const TitleAssets = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.button.fontWeight,
  fontSize: theme.typography.button.fontSize,
  letterSpacing: '0px',
  textDecoration: 'none',
  lineHeight: '126.49999856948853%',
  textTransform: 'none',
  margin: '0px',
}));
const IteractionAssetsFilt = styled(Stack)({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  margin: '0px',
});
const BodyTransactionsWallet = ({
  isWallet,
  titleText = 'Mis Transacciones',
  column,
  transactions,
  loadingTransactions,
  errorTransactions,
  refetchTransactions,
  balanceData,
  loadingBalance,
  errorBalance,
  refetchBalance,
}) => {
  const filterStatusTransactions = transactions?.filter(({ status }) => status === 4);
  const theme = useTheme();
  const isSurfacePro = useMediaQuery('(min-width:960px) and (max-width:1400px)');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sortedArrayDateStatusTransactions = filterStatusTransactions
    ?.filter(({ subType }) => subType === 'CONT' || subType === 'WTHD' || subType === 'DIV')
    .sort((a, b) => {
      const prevDate = new Date(a.tradeDate);
      const currentDate = new Date(b.tradeDate);
      return currentDate.getTime() - prevDate.getTime();
    });
  return (
    <>
      <WrapperSection>
        <TitleContainer>
          <TitleText>Caja</TitleText>
        </TitleContainer>
        <Stack
          direction={{
            xs: 'column',
            sm: 'column',
            md: 'column',
            lg: 'row',
          }}
          spacing={4}
          width='100%'
          justifyContent='center'
          alignItems={{ xs: 'center', md: 'flex-start' }}
          marginTop={{ xs: '-8px', md: '12px' }}>
          <Stack
            direction={column}
            sx={{
              width: {
                xs: '100%',
                sm: '100%',
                md: '100%',
                lg: '40%',
              },
            }}>
            <StackAvailable>
              <ErrorBoundaryXcala onlyImage imageWidth='90px' imageHeight='90px'>
                <TotalWallet
                  balance={balanceData?.totalAmount}
                  loadingBalance={loadingBalance}
                  errorBalance={errorBalance}
                />
              </ErrorBoundaryXcala>
            </StackAvailable>
            <Stack sx={{ margin: 0, height: '140px', width: '100%' }}>
              {isWallet === true ? (
                <Box sx={{ margin: 0, width: '100%' }}>
                  <CoinFloating
                    balanceData={balanceData}
                    loadingBalance={loadingBalance}
                    errorBalance={errorBalance}
                  />
                </Box>
              ) : null}
            </Stack>
            <Stack>
              <BtnGroupWallet
                refetchTransactions={refetchTransactions}
                refetchBalance={refetchBalance}
                balanceData={balanceData}
                transactions={transactions}
              />
            </Stack>
          </Stack>
          <StackTransaction>
            <AssetsTitle gap={1} flexDirection={{ md: 'row', xs: 'column' }}>
              <TitleAssets>{titleText}</TitleAssets>
              <IteractionAssetsFilt gap={1} />
            </AssetsTitle>
            <Stack width={'100%'}>
              <ErrorBoundaryXcala
                responsiveMobile
                width='100%'
                height='100%'
                minHeight={{ xs: '200px', sm: '230px', md: '315px' }}
                imageWidth='90px'
                imageHeight='90px'
                fontSizeTop='18px'
                fontSizeBottom='18px'>
                <TabletGridWallet
                  column={column}
                  filterStatusTransactions={filterStatusTransactions}
                  sortedArrayDateStatusTransactions={sortedArrayDateStatusTransactions}
                  loadingTransactions={loadingTransactions}
                  errorTransactions={errorTransactions}
                />
              </ErrorBoundaryXcala>
            </Stack>
          </StackTransaction>
        </Stack>
      </WrapperSection>
    </>
  );
};

export default BodyTransactionsWallet;
